// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"_3YxF","dark":"_3Lhx","overlay":"_1KUX","translucent":"oBXZ","transparent":"Kn-p"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Overlay/Overlay.scss
// module id = W1/l
// module chunks = 0